import { render } from "./DetailCustomResponse.vue?vue&type=template&id=9bb57b64&scoped=true"
import script from "./DetailCustomResponse.vue?vue&type=script&lang=js"
export * from "./DetailCustomResponse.vue?vue&type=script&lang=js"

import "./DetailCustomResponse.vue?vue&type=style&index=0&id=9bb57b64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb57b64"]])

export default __exports__